var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Artwork_6",
    "data-name": "Artwork 6",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.065,
    height: 30.472,
    viewBox: "0 0 14.065 30.472",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M822.808,239.328h-3.32c-1.174,0-1.417.48-1.417,1.693v2.93h4.737l-.455,5.145h-4.281v15.366h-6.137v-15.3h-3.192V243.95h3.192v-4.1c0-3.85,2.059-5.859,6.625-5.859h4.249Z",
    transform: "translate(-808.743 -233.989)",
    fill: "#fcbf49"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.518210ad054d7dfc77de5c66e9439c5f.svg";
export { ForwardRef as ReactComponent };